import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';

const LoginPage = lazy(() => import('./pages/LoginPage'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Teachers = lazy(() => import('./pages/Teachers'));
const Students = lazy(() => import('./pages/Students'));
const Enrollments = lazy(() => import('./pages/Enrollments'));
const Attendance = lazy(() => import('./pages/Attendance'));
const AttendanceDetail = lazy(() => import('./pages/AttendanceDetail'));
const StatsFees = lazy(() => import('./pages/StatsFees'));
const StatsTeacherIncome = lazy(() => import('./pages/StatsTeacherIncome'));
const StatsAttendance = lazy(() => import('./pages/StatsAttendance'));
const Classes = lazy(() => import('./pages/Classes'));
const Account = lazy(() => import('./pages/Account'));
const CourseCategories = lazy(() => import('./pages/CourseCategories'));
const Approvals = lazy(() => import('./pages/Approvals'));

import Layout from './components/Layout';

function RequireAuth({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="classes" element={<Classes />} />
          <Route path="course-categories" element={<CourseCategories />} />
          <Route path="teachers" element={<Teachers />} />
          <Route path="students" element={<Students />} />
          <Route path="enrollments" element={<Enrollments />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="attendance/:id" element={<AttendanceDetail />} />
          <Route path="stats/fees" element={<StatsFees />} />
          <Route path="stats/teacher-income" element={<StatsTeacherIncome />} />
          <Route path="stats/attendance" element={<StatsAttendance />} />
          <Route path="approvals" element={<Approvals />} />
          <Route path="account" element={<Account />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
